module.exports = __webpack_public_path__ + "static/4-229f710b4e98f5c58a65aef00b6de514.jpeg";